import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import NavBar from "ui/NavBar/NavBar";
import SideDrawer from "ui/SideDrawer/SideDrawer";
import Backdrop from "ui/Backdrop/Backdrop";
import "ui/UI.css";
//import UIroot from "ui/UIroot";
//import UI2 from "ui/UI2";
import UILogin from "ui/UILogin";
import UIMessageList from "ui/UIMessageList";

import GlobalContext from "contexts/context";
import DatabaseContext from "data/contextDatabase";

//import { useDerivedLocalKey, encrypt, decrypt } from "hooks/encryptionHooks";
import { timestamp, randomString } from "hooks/helper";
import { timeoutGet } from "hooks/http";
import { useLiveUser } from "hooks/dbHooks";
import { useLiveClient } from "hooks/dbHooks";
import { useLiveCount } from "hooks/dbHooks";

const UserInterface = (props) => {
  // Anything here acts as componentWillMount
  const [sideDrawerOpen, setSideDrawerOpen] = useState(false);
  const drawerToggleClickHandler = () => setSideDrawerOpen(!sideDrawerOpen);
  const backdropClickHandler = () => setSideDrawerOpen(false);

  //-----------------------------

  const { globalState, globalDispatch } = useContext(GlobalContext);
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const liveUser = useLiveUser(databaseState.dbUser);
  const liveClient = useLiveClient(databaseState.dbUser);
  const liveCount = useLiveCount(databaseState.dbMaster);

  useEffect(() => {
    databaseDispatch({
      type: "CACHE_COUNT",
      values: {
        liveCount: liveCount,
      },
    });
    return () => {};
  }, [databaseDispatch, liveCount]);

  useEffect(() => {
    // if uid changes, request a list of personas via REST
    // store them in account data
    // use the first persona to join any dialog indicated in the url
    if (
      databaseState.dbMaster === null ||
      globalState.uid === undefined ||
      globalState.password === undefined
    ) {
      console.log(
        "UILogin null",
        databaseState.dbMaster,
        globalState.uid,
        globalState.password
      );
    } else {
      const sortJoin = (A, B, Delim) => {
        return A < B ? A + Delim + B : B + Delim + A;
      };

      const addDialog = (muid, mpersona, persona, peer, peerpersona) => {
        let d = {
          dialog: peerpersona,
          got_voice: true,
          mdialog: sortJoin(mpersona, peer, "_"),
          mpersona: mpersona,
          persona: persona,
          peer: peer,
          peerpersona: peerpersona,
          visibility: "PRIVATE_DIALOG",
        };
        databaseDispatch({
          type: "UPSERT_REC",
          values: {
            db: databaseState.dbMaster,
            collection: "dialog",
            table: muid,
            rowid: sortJoin(mpersona, peer, "_"),
            doc: d,
          },
        });
        // send a welcome message
        let j = {
          type: "w.mpersona.message",
          content: {
            body: "Thanks for joining the conversation... type your messages in the box below",
            msgtype: "w.text",
          },
          mpersona: mpersona,
          peer: peer,
          visibility: "PRIVATE_DIALOG",
          name: "Invitation manager",
          ts_sender: timestamp(),
          smid: sortJoin(mpersona, peer, "_"), // using this as smid prevents multiple copies of the message
          status: "1",
          origin_sender: "registered",
          thumbnail: "",
          lat: "",
          lon: "",
          persona_picture: "",
          version: globalState.version,
        };
        databaseDispatch({
          type: "UPSERT_REC",
          values: {
            jmessage: j,
            db: databaseState.dbMaster,
            collection: "send",
            table: "confirm_smid",
            rowid: j.smid,
            doc: j,
          },
        });
      };

      const urlPersona =
        "https://2avoul47dg.execute-api.eu-central-1.amazonaws.com/prod";

      timeoutGet(urlPersona, {
        type: "personalist",
        uid: globalState.uid,
        pwd: globalState.password,
        msgid: randomString(8),
      }).then((personaList) => {
        personaList === undefined
          ? console.log()
          : databaseDispatch({
              type: "UPSERT_REC",
              values: {
                db: databaseState.dbMaster,
                collection: "account_data",
                table: "personas",
                rowid: "muid", // personaList.muid,
                doc: personaList,
              },
            });
        // use 1st persona to join url dialogs
        try {
          let dialogList = JSON.parse(sessionStorage.getItem("dialoglist"));
          // set targetDialog to allow navigation directly to dialog
          // dialogList &&
          //   dialogList[0] &&
          //   sessionStorage.setItem("targetdialog", dialogList[0].peer);
          dialogList.map((jd) => {
            addDialog(
              personaList.muid,
              personaList.list[0].mpersona,
              personaList.list[0].persona,
              jd.peer,
              jd.peerpersona
            );
          });
          sessionStorage.removeItem("dialoglist");
        } catch {}
      });
    }
    return () => {};
  }, [
    databaseDispatch,
    databaseState.dbMaster,
    globalState.password,
    globalState.uid,
  ]);

  useEffect(() => {
    // if uid and pwd change, save them in the dbUser
    if (globalState.uid === undefined || globalState.password === undefined) {
      console.log(globalState.uid, globalState.password);
    } else {
      // // Save encrypted username and password in database
      // let strData = JSON.stringify({
      //   uid: globalState.uid,
      //   password: globalState.password,
      // });

      // encrypt(derivedLocalKey, strData).then((enc_user) => {
      //   console.log("UILogin derivedLocalKey ", derivedLocalKey);
      //   console.log("UILogin enc_user ", enc_user);
      //   let recs = [
      //     { _id: "key_user", key: derivedLocalKey },
      //     { _id: "user", user: enc_user },
      //   ];
      console.log(
        "UILogin upsert user : ",
        globalState.uid,
        globalState.password
      );

      databaseDispatch({
        type: "UPSERT_REC_ID",
        values: {
          db: databaseState.dbUser,
          doc: {
            _id: "user",
            uid: globalState.uid,
            password: globalState.password,
          },
        },
      });
      // databaseDispatch({
      //   type: "UPSERT_REC_ID",
      //   values: {
      //     db: databaseState.dbUser,
      //     doc: { _id: "user", user: enc_user },
      //   },
      // });
      // });
    }
    return () => {};
  }, [
    databaseDispatch,
    databaseState.dbUser,
    globalState.password,
    globalState.uid,
  ]);

  useEffect(() => {
    // if uid or pwd change, and if a dBMaster exists
    // try retrieve a stored muid paired to the uid
    if (
      globalState.uid === null ||
      globalState.uid === undefined ||
      databaseState.dbMaster === null ||
      databaseState.dbMaster?.name !== globalState.uid ||
      databaseState.dbReady !== true
    ) {
      console.log("UILogin dbMaster null");
    } else {
      console.log(
        "UILogin match muid for : ",
        globalState.uid,
        databaseState.dbMaster,
        databaseState.dbReady
      );
      // globalDispatch({
      //   type: "SET_MUID",
      //   values: { muid: undefined },
      // });
      // TODO MULTI-USER: account_data4user_info4muid should be stored for all users
      databaseState.dbMaster
        .get("54account_data4user_info4muid")
        .then((m) => {
          console.log("UILogin found muid: ", m);
          try {
            if (m.uid === globalState.uid) {
              globalDispatch({
                type: "SET_MUID",
                values: { muid: m.muid },
              });
            }
          } catch (err) {
            console.log("UILogin error: ", err);
          }
        })
        .catch((err) => console.log("UILogin muid error: ", err));
    }

    return () => {};
  }, [
    databaseState.dbMaster,
    databaseState.dbReady,
    globalDispatch,
    globalState.uid,
  ]);

  useEffect(() => {
    // If dbUser exists, attempt to log in with stored user
    liveClient?.cid &&
      liveUser?.uid &&
      liveUser?.password &&
      globalDispatch({
        type: "LOGIN",
        values: {
          uid: liveUser.uid,
          password: liveUser.password,
          muid: undefined,
          cid: liveClient?.cid,
        },
      });
    return () => {};
  }, [globalDispatch, liveUser, liveClient]);

  useEffect(() => {
    let dialoglist = [];
    let tasklist = [];
    let firstTargetType;
    console.log("URL: ", window.location);
    const pathArray = window.location.pathname.split("/");
    console.log("URL array: ", pathArray);
    for (let i = 0; i < pathArray.length; i++) {
      if (pathArray[i] === "dialog" && pathArray.length > i + 2) {
        !firstTargetType && (firstTargetType = "dialog");
        dialoglist = [
          ...dialoglist,
          { peer: pathArray[i + 1], peerpersona: pathArray[i + 2] },
        ];
        i = i + 2;
      } else if (pathArray[i] === "topic" && pathArray.length > i + 1) {
        !firstTargetType && (firstTargetType = "mtopic");
        let j = {
          version: globalState.version,
          type: "w.topic.subscribe.mtopic",
          source: "link",
          mtopic: pathArray[i + 1],
          smid: randomString(8),
        };
        tasklist = [...tasklist, j];
        i = i + 1;
      }
    }

    console.log("firstTargetType: ", firstTargetType);

    const paramsArray = window.location.search.substr(1).split("&");
    let params = {};
    for (let i = 0; i < paramsArray.length; ++i) {
      let param = paramsArray[i].split("=", 2);
      if (param.length !== 2) continue;
      params[param[0]] = decodeURIComponent(param[1].replace(/\+/g, " ")).split(
        ","
      );
    }

    if (params.t !== null && params.t !== undefined) {
      for (let t = 0; t < params.t.length; ++t) {
        let j = {
          version: globalState.version,
          type: "w.topic.subscribe.mtopic",
          source: "link",
          mtopic: params.t[t],
          smid: randomString(8),
        };
        tasklist = [...tasklist, j];
      }
    }

    tasklist.length > 0 &&
      sessionStorage.setItem("tasklist", JSON.stringify(tasklist));

    if (
      params.d !== null &&
      params.d !== undefined &&
      params.n !== null &&
      params.n !== undefined &&
      params.d.length === params.n.length
    ) {
      console.log("params: ", params);
      for (let d = 0; d < params.d.length; d++) {
        dialoglist = [
          ...dialoglist,
          { peer: params.d[d], peerpersona: params.n[d] },
        ];
      }
    }
    dialoglist.length > 0 &&
      sessionStorage.setItem("dialoglist", JSON.stringify(dialoglist));

    firstTargetType === "mtopic" &&
      sessionStorage.setItem("targetmtopic", tasklist[0].mtopic);
    firstTargetType === "dialog" &&
      sessionStorage.setItem("targetdialog", dialoglist[0].peer);

    return () => {};
  }, [globalState.version]);
  //-----------------------------

  useEffect(() => {
    // This runs after component is rendered ... every time
    console.log("UserInterface component rendered");
  });

  useEffect(() => {
    // This runs after component is rendered ... first time. The [] indicates "no dependencies"
    // so this is like componentDidMount
    console.log("UserInterface component is rendered ... first time");
    return () => {
      console.log(
        "UserInterface component runs componentWillUnmount for the last time"
      );
    };
  }, []);

  useEffect(() => {
    // this is like componentDidUpdate
    console.log(
      "UserInterface componentDidUpdate because props changed ",
      props
    );

    return () => {
      // this is like componentWillUnmount
      console.log("UserInterface componentWillUnmount because props changed");
    };
  }, [props]);

  let backdrop;

  if (sideDrawerOpen) {
    backdrop = <Backdrop click={backdropClickHandler} />;
  }

  let content = (
    <div style={{ height: "100%" }}>
      <Router>
        <NavBar toggleDrawer={drawerToggleClickHandler} />
        <SideDrawer
          show={sideDrawerOpen}
          closeSideDrawer={() => setSideDrawerOpen(false)}
        />
        {backdrop}
        <main
          style={{
            position: "absolute",
            height: "calc(100% - 56px)",
            top: "56px",
            width: "100%",
          }}
        >
          <Switch>
            {/* <Route path="/UI2" exact component={UI2} /> */}
            <Route path="/UILogin" exact component={UILogin} />
            <Route path="/UIMessageList" exact component={UIMessageList} />
            <Route path="/UILogin" component={UILogin} />
            <Route path="/" component={UILogin} />
          </Switch>
        </main>
      </Router>
    </div>
  );

  return content;
};

// memo acts like shouldComponentUpdate ... can use without the function, or with a function that returns false if it SHOULD rerender
export default React.memo(UserInterface, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
